// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oSvbi0EUGGdifkDu6cOQ{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
}
  
  

.vyzhI8tA5ila4g5aDhPN{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
}
.ZWSCjXlmCA7d8auK3u7i{
    font-size: 24px;
    font-weight: 600;
}

.QpVkWMCA0bvfzD2t58UZ, .EgzY3d2DgkhX0StvYQDq{
    display: flex;
    flex-direction: column;
    box-sizing: border-box;   

}

.QpVkWMCA0bvfzD2t58UZ{
    width: 100%;
    justify-content: left;
    align-items: flex-start;
}

.EgzY3d2DgkhX0StvYQDq{
    justify-content: space-between;
    align-items: center;
    width: 184px;
    height: 80px;
}


.t2kAHp1ZWZA3CF3wB2te{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    margin-top: 8px;
    box-sizing: border-box;
    width: 100%;
}

.k_eT4YhjSr2bWd1SCXAy{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 88px;
    margin:0;
    padding: 0;
    border: 1px solid var(--border-medium);

}
.fl6ilA6oS3zbOukktAmW, .mXjrwxPeKmXuXcA_yRkr, .jNn4SXTtCrRu9Nn8dmkD, .MIXCHyLnXjWDxkkk59Vk{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 32px;
    padding: 16px;
    margin-top: 8px;
    box-sizing: border-box;
}

.fl6ilA6oS3zbOukktAmW, .MIXCHyLnXjWDxkkk59Vk{
    border: 1px solid var(--border-medium);
}

.mXjrwxPeKmXuXcA_yRkr, .MIXCHyLnXjWDxkkk59Vk{
    background-color: var(--background-dark);
    font-size: 20px;
    font-weight: 600;
    color: var(--letter-light);

}

.mXjrwxPeKmXuXcA_yRkr{
    border: none
}

.vwXOYAyn68ghqMoY0i1n, .GjTRDzvsV5WxZJfcI4gc, .xz0GX0qDAJTQdUVBx79o, .fx7o_T9wyNlxfX4aP47U, .IOhkUgvHsRHcYYpqNd_Q, .dPTaNu7hWjDTi3ECrVso, .zYks8ySPRWgIUDFQMNVm,.ax_zQoSxYtlJWY2cNQqx, .OnarS3_7Xi0Go1AJpFlg{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    height: 24px;
    margin-right: 24px;
    box-sizing: border-box;
}   

.vwXOYAyn68ghqMoY0i1n{
    width: 280px;
}

.ax_zQoSxYtlJWY2cNQqx{
    width: 160px;
}

.OnarS3_7Xi0Go1AJpFlg{
    width: 160px;
}

.GjTRDzvsV5WxZJfcI4gc{
    width: 100px;
}

.fx7o_T9wyNlxfX4aP47U{
    width: 215px;
}

.xz0GX0qDAJTQdUVBx79o{
    width: 70px;
    justify-content: center;
    line-break: auto;
    font-size: 14px;
    text-align: center;
}

.IOhkUgvHsRHcYYpqNd_Q{
    width: 60px;
    justify-content: center;
    line-break: auto;
    font-size: 14px;
    text-align: center;
}

.dPTaNu7hWjDTi3ECrVso{
    width: 50px;
    justify-content: center;
}

.zYks8ySPRWgIUDFQMNVm{
    width: 60px;
}`, "",{"version":3,"sources":["webpack://./clientRoot/Static/RunningServiceOrdersPanel/RunningServiceOrdersPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;;AAE1B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,sCAAsC;;AAE1C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;;AAE9B;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".providersPanel{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    width: 100%;\n    padding: 16px;\n    box-sizing: border-box;\n}\n  \n  \n\n.providersPanelHeader{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    box-sizing: border-box;\n}\n.providersPanelTitle{\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.providersList, .providersPanelButtons{\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;   \n\n}\n\n.providersList{\n    width: 100%;\n    justify-content: left;\n    align-items: flex-start;\n}\n\n.providersPanelButtons{\n    justify-content: space-between;\n    align-items: center;\n    width: 184px;\n    height: 80px;\n}\n\n\n.providersListMainRow{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    margin-top: 8px;\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.edit{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n    width: 100%;\n    height: 88px;\n    margin:0;\n    padding: 0;\n    border: 1px solid var(--border-medium);\n\n}\n.provider, .providersListHeader, .editLine, .providersReportHeader{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: 32px;\n    padding: 16px;\n    margin-top: 8px;\n    box-sizing: border-box;\n}\n\n.provider, .providersReportHeader{\n    border: 1px solid var(--border-medium);\n}\n\n.providersListHeader, .providersReportHeader{\n    background-color: var(--background-dark);\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--letter-light);\n\n}\n\n.providersListHeader{\n    border: none\n}\n\n.providerName, .affiliateId, .numberOfServiceOrders, .phoneNumber, .validWhatsapp, .editProvider, .providerStatus,.editingType, .editingDate{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    height: 24px;\n    margin-right: 24px;\n    box-sizing: border-box;\n}   \n\n.providerName{\n    width: 280px;\n}\n\n.editingType{\n    width: 160px;\n}\n\n.editingDate{\n    width: 160px;\n}\n\n.affiliateId{\n    width: 100px;\n}\n\n.phoneNumber{\n    width: 215px;\n}\n\n.numberOfServiceOrders{\n    width: 70px;\n    justify-content: center;\n    line-break: auto;\n    font-size: 14px;\n    text-align: center;\n}\n\n.validWhatsapp{\n    width: 60px;\n    justify-content: center;\n    line-break: auto;\n    font-size: 14px;\n    text-align: center;\n}\n\n.editProvider{\n    width: 50px;\n    justify-content: center;\n}\n\n.providerStatus{\n    width: 60px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"providersPanel": `oSvbi0EUGGdifkDu6cOQ`,
	"providersPanelHeader": `vyzhI8tA5ila4g5aDhPN`,
	"providersPanelTitle": `ZWSCjXlmCA7d8auK3u7i`,
	"providersList": `QpVkWMCA0bvfzD2t58UZ`,
	"providersPanelButtons": `EgzY3d2DgkhX0StvYQDq`,
	"providersListMainRow": `t2kAHp1ZWZA3CF3wB2te`,
	"edit": `k_eT4YhjSr2bWd1SCXAy`,
	"provider": `fl6ilA6oS3zbOukktAmW`,
	"providersListHeader": `mXjrwxPeKmXuXcA_yRkr`,
	"editLine": `jNn4SXTtCrRu9Nn8dmkD`,
	"providersReportHeader": `MIXCHyLnXjWDxkkk59Vk`,
	"providerName": `vwXOYAyn68ghqMoY0i1n`,
	"affiliateId": `GjTRDzvsV5WxZJfcI4gc`,
	"numberOfServiceOrders": `xz0GX0qDAJTQdUVBx79o`,
	"phoneNumber": `fx7o_T9wyNlxfX4aP47U`,
	"validWhatsapp": `IOhkUgvHsRHcYYpqNd_Q`,
	"editProvider": `dPTaNu7hWjDTi3ECrVso`,
	"providerStatus": `zYks8ySPRWgIUDFQMNVm`,
	"editingType": `ax_zQoSxYtlJWY2cNQqx`,
	"editingDate": `OnarS3_7Xi0Go1AJpFlg`
};
export default ___CSS_LOADER_EXPORT___;
